var React = require('react');

function BigArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M56.2702 52.4912L71.4785 37.4912L56.2702 22.4912","stroke":"black","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M71.4785 37.4912H1.52018","stroke":"black","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

BigArrowRight.defaultProps = {"width":"73","height":"72","viewBox":"0 0 73 72","fill":"none"};

module.exports = BigArrowRight;

BigArrowRight.default = BigArrowRight;
